const oeaLinks = [
  {
    href: "/presidentWord",
    as: "/presidentWord",
    title: "presidentWord",
  },
  {
    href: "/syndicateOverview",
    as: "/syndicateOverview",
    title: "syndicateOverview",
  },
  { href: "/laws", as: "/laws", title: "lawsAndRegulations" },
  { href: "/joinOEA", as: "/joinOEA", title: "joinOea" },
];
const technicalOfficeLinks = [
  { href: "/technicalOffice", as: "/technicalOffice", title: "monthlyReports" },
  {
    href: "/technicalOfficePubs/[category]",
    as: "/technicalOfficePubs/all",
    title: "technicalOfficePubs",
  },
];

const newsLinks = [
  {
    title: "Announcements",
    href: "/news/announcements",
    as: "/news/announcements",
  },
  {
    title: "webinarsSchedule",
    href: "/webinarsSchedule",
    as: "/webinarsSchedule",
  },
  {
    title: "Activities",
    href: "/news/activities",
    as: "/news/activities",
  },
  // {
  //   title: "Mortality",
  //   href: "/news/[...params]",
  //   as: "/news/mortality",
  // },
  {
    title: "discountsAndBenefits",
    href: "/benefits",
    as: "/benefits",
  },
];
module.exports = {
  oeaLinks,
  technicalOfficeLinks,
  newsLinks,
};
